import { render, staticRenderFns } from "./ContentType.vue?vue&type=template&id=7185a7e3&scoped=true&"
import script from "./ContentType.vue?vue&type=script&lang=js&"
export * from "./ContentType.vue?vue&type=script&lang=js&"
import style0 from "./ContentType.vue?vue&type=style&index=0&id=7185a7e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7185a7e3",
  null
  
)

export default component.exports